<template>
	<div>
		<vxe-button size="mini" content="批量修改" @click="clickEvent"></vxe-button>
		<vxe-modal v-model="modelShow" width="400" height="auto" title="修改字段" @show="show" @hide="hide" 
			show-close :mask="false" :draggable="false" :showFooter="true" transfer>
			<div ref="batchmodify" style="margin-top: 10px;margin-bottom: 10px;"></div>
			<template #footer>
				<vxe-button status="" content="取消" @click="cancle"></vxe-button>
				<vxe-button status="primary" content="确定" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>

</template>
<style>
	.form_loading {
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
</style>
<style scoped>

</style>
<script>
	const batchmodifyRes = {
		rule: {
			"width": "400",
			"height": "auto",
			"fApi": [],
			// "rule": [{
			// 		"type": "$warehouse",
			// 		"field": "name",
			// 		"title": "职务名称",
			// 		"value": null,
			// 		"props": []
			// 	},
			// 	{
			// 		"type": "$emun",
			// 		"field": "enable",
			// 		"title": "是否启用",
			// 		"value": null,
			// 		"props": {
			// 			"name": "enable",
			// 			"initValue": null
			// 		}
			// 	}
			// ],
			"option": {
				"form": {
					"labelWidth": "120px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	export default {
		props: {
			fields: {
				type: Array,
				default: () => {
					return []
				}
			},
			table: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				fApi:null,
				modelShow: false,
				rule: {}
			}
		},
		created() {

		},
		mounted(){
			this.init()
		},
		watch: {

		},
		computed: {

		},
		methods: {
			init() {
				let rule = []
				let res = JSON.parse(JSON.stringify(batchmodifyRes))
				this.rule = res.rule
				this.fields.forEach((item) => {
					if (!item.hidden && !item.props.disabled && !item.props.readonly && item.type!='$quote') {
						rule.push({
									type: item.type,
									field: item.field,
									title: item.title,
									value: null,
									props: item.props
									
						})
					}
				})
				this.rule.rule = rule
				this.modalShow = true
			},
			show() {
				let rule = this.rule.rule
				let option = this.rule.option
				option.el = this.$refs.batchmodify
				if(!this.fApi){
					this.fApi = this.$formCreate(rule, option)
				}
				
			},
			hide() {
			
			},
			clickEvent() {
				if(this.rule.rule.length==0){
					this.$message.error('暂无可修改项')
				}else{
					this.modelShow = true
				}
				
			},
			cancle(){
				this.modelShow = false
			},
			submit(){
				let data = this.fApi.formData()
				let fullData = this.table.getTableData().fullData
				for(let i in data){
					if(data[i]!= null){
						fullData.forEach((item)=>{
							item[i] = data[i]
						})
					}
				}
				this.$emit('submit', {
					code: 'batchmodify',
					data: data,
					table:this.table
				})
				this.fApi.resetFields()	
				this.modelShow = false
			}
		},
		components: {

		}
	}
</script>
